// src/components/freemium/FreemiumTabs.tsx
// Tools / Documents / Messages tabs for Freemium pages
// Extracted from global header to be used in page-level headers

import React from 'react';
import { useFilter } from '../../contexts/FilterContext';

interface FreemiumTabsProps {
  messageCount?: number;
}

export default function FreemiumTabs({ messageCount = 0 }: FreemiumTabsProps) {
  const { activeFilter, setActiveFilter } = useFilter();

  const handleTabChange = (tab: string) => {
    if (tab === 'Tools' || tab === 'Documents' || tab === 'Messages') {
      setActiveFilter(tab);
    }
  };

  return (
    <div className="h-10 flex items-center justify-end gap-2 pt-3 mb-0.5">
      <nav className="flex items-center gap-2" aria-label="Section navigation">
        {['Tools', 'Documents', 'Messages'].map((tab) => {
          const active = tab === activeFilter;
          const isMessages = tab === 'Messages';
          const showBadge = isMessages && messageCount > 0;
          
          return (
            <button
              key={tab}
              onClick={() => handleTabChange(tab)}
              className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors relative
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#18365E]
                ${active ? "bg-[#18365E] text-white" : "text-[#18365E] hover:bg-black/5"}`}
              aria-current={active ? "page" : undefined}
            >
              {tab}
              {showBadge && (
                <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-[#FF6E4C] text-[10px] font-bold text-white">
                  {messageCount}
                </span>
              )}
            </button>
          );
        })}
      </nav>
    </div>
  );
}

